// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs"
import Turbolinks from "turbolinks"
import * as ActiveStorage from "@rails/activestorage"
import "channels"
import "bootstrap"
import "jquery"
//import "chartkick/chart.js"
// import 'bootstrap-icons/font/bootstrap-icons.css'

// Datatable
import 'datatables.net-bs4'
import 'datatables.net-editor-bs4'
import 'datatables.net-buttons-bs4'
import 'datatables.net-buttons/js/buttons.colVis.js'
import 'datatables.net-buttons/js/buttons.html5.js'
import 'datatables.net-buttons/js/buttons.print.js'
import 'datatables.net-datetime'
import 'datatables.net-responsive-bs4'
import 'datatables.net-scroller-bs4'

// Custom Javascript
require('./custom/datatable');

import $ from 'jquery';

global.$ = jQuery;

Rails.start()
Turbolinks.start()
ActiveStorage.start()
